import {z} from '@hono/zod-openapi';

/** `car_details`: `adId` may be repeated to ask for several advertisements at once. */
export const priceReportCarDetailsQuerySchema = z.object({
  adId: z.union([z.string(), z.array(z.string())]).optional(),
});
